import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('fraud_detection_changes_made_after_approval'),
    subtitle: defineMessage('which_changes_made_in_q_isations_administrators'),
    optionNetAmount: defineMessage('net_total_amount_more_t_panycurrencycode_change'),
    optionVendorId: defineMessage('vendor'),
    optionPayee: defineMessage('payee'),
    optionPaymentDetails: defineMessage('payment_details'),
    optionLineItemProduct: defineMessage('productservice'),
    optionLineItemCategory: defineMessage('category'),
    optionLocation: defineMessage('location'),
    optionLineItemClass: defineMessage('class'),
    optionLineItemDescription: defineMessage('description_more_than_difference'),
    optionCurrency: defineMessage('currency'),
};
